import { Routes, Route } from "react-router-dom";
import Layout from "./layouts/Layout";
import Home from "./views/Home";
import About from "./views/About";
import Meetings from "./views/Meetings";
import ContactUs from "./views/Contact";
import News from "./views/News";
import Team from "./views/Teams";
import Centers from "./views/Centers";
import ViewMeeting from "./views/ViewMeeting";


function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="home" element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="centers" element={<Centers />} />
        <Route path="meetings" element={<Meetings />} />
        <Route path="news" element={<News />} />
        <Route path="team" element={<Team />} />
        <Route path="contactus" element={<ContactUs />} />
        <Route path="/ViewMeeting/:id" element={<ViewMeeting />} />;
      </Route>
    </Routes>
  );
}

export default App;